<template> 
    <div>
        <div v-if="loading">

            <ring-loader/>
        </div>


        <div v-else>

            
                <public-pitches :pitchSlot="pitchesList"/>
        </div>

    </div>
</template>

<script> 

import axios from '@/classes/myAxios'

import publicPitches from './PublicPitches.vue'

    export default {

        async mounted(){

            // console.log(`in public info pitches`);

            await this.loadData();


            let result = await this.$auth.isAuthenticated();
            
            // console.log(`result: ${result}`);

            if(result == true){

                this.$router.push({ path: 'bookingPitches' })
            }
        },

         props:{

            isFromBusinessPage: false,
            myBusinessId: 0,
        },

        components:{

            publicPitches
        },

        methods:{

            async loadData(){

                try{

                    this.loading = true;
                    let result;

                    if(this.isFromBusinessPage){

                        result = await axios({method: 'post',url: '/pnadiapi/forPublicInfo/getPitchesWithId',
                            data: {
                            
                                businessId: this.myBusinessId,
                            }
                    });
                    }
                    else{

                        result = await axios({method: 'post',url: '/pnadiapi/forPublicInfo/getPitches',
                            data: {
                            
                            } 
                        });
                    }


                // console.log(`result.data.length: ${JSON.stringify(result.data.two_pitch_slot.length)}`);

                    this.pitchesList = result.data.two_pitch_slot;

                    this.loading = false;

                }catch(error){

                    this.loading = false;

                }
            }
        },

        data(){

            return{

                pitchesList: [],
                loading: false
            }
        }
     }
</script>

<style>

</style>